import { IcoX, IcoEraser } from "./icons";

// ─── Clear Review Modal ────────────────────────────────────────────────────

export default function ClearReviewModal({
  onClose,
  clearEPH,
  setClearEPH,
  clearVendor,
  setClearVendor,
  reviewEphRecords,
  reviewVendorRecords,
  reviewNotFoundRecords = [],
  clearNotFound,
  setClearNotFound,
  checkedRecords,
  setCheckedRecords,
  setSelections,
}) {
  const handleConfirmClear = () => {
    const toClear = [
      ...(clearEPH ? reviewEphRecords.map((r) => r.id) : []),
      ...(clearVendor ? reviewVendorRecords.map((r) => r.id) : []),
      ...(clearNotFound ? reviewNotFoundRecords.map((r) => r.id) : []),
    ];
    setCheckedRecords((prev) => {
      const n = new Set(prev);
      toClear.forEach((id) => n.delete(id));
      return n;
    });
    setSelections((prev) => {
      const n = { ...prev };
      toClear.forEach((id) => delete n[id]);
      return n;
    });
    onClose();
  };

  return (
    <div className="rc-mover" onClick={onClose}>
      <div className="rc-mdl sm" onClick={(e) => e.stopPropagation()}>
        <div className="rc-mdl-hdr neut">
          <div className="rc-mdl-hl">
            <div className="rc-mdl-ico">
              <IcoEraser size={15} cls="ic-f" />
            </div>
            <p className="rc-mdl-htit">Clear Review</p>
          </div>
          <button className="rc-mdl-close" onClick={onClose}>
            <IcoX size={15} />
          </button>
        </div>
        <div className="rc-mdl-body plain">
          <p className="rc-mdl-desc">
            Select which reviews to clear. This will remove all selections
            and checked records for the chosen tabs.
          </p>
          <div className="rc-chk-list">
            {[
              {
                label: "Clear EPH Review",
                val: clearEPH,
                set: setClearEPH,
                count: reviewEphRecords.filter((r) => checkedRecords.has(r.id))
                  .length,
              },
              {
                label: "Clear Vendor Review",
                val: clearVendor,
                set: setClearVendor,
                count: reviewVendorRecords.filter((r) =>
                  checkedRecords.has(r.id),
                ).length,
              },
              ...(reviewNotFoundRecords.length > 0
                ? [
                    {
                      label: "Clear Not Found Review",
                      val: clearNotFound,
                      set: setClearNotFound,
                      count: reviewNotFoundRecords.filter((r) =>
                        checkedRecords.has(r.id),
                      ).length,
                    },
                  ]
                : []),
            ].map(({ label, val, set, count }) => (
              <label key={label} className="rc-chk-item">
                <input
                  type="checkbox"
                  checked={val}
                  onChange={(e) => set(e.target.checked)}
                />
                <div>
                  <p className="rc-chk-item-lbl">{label}</p>
                  <p className="rc-chk-item-sub">
                    {count} reviewed record{count !== 1 ? "s" : ""} will be
                    cleared
                  </p>
                </div>
              </label>
            ))}
          </div>
        </div>
        <div className="rc-mdl-foot">
          <button className="btn btn-o" style={{ flex: 1 }} onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-r"
            style={{ flex: 1 }}
            disabled={!clearEPH && !clearVendor && !clearNotFound}
            onClick={handleConfirmClear}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
